import { updateStoredValues, validatePaymentsInfo } from '../helpers';

// TODO: Add unit tests
const updateICOTradeIn = (_ref, walletStorageService) => {
  let {
    types,
    initialState
  } = _ref;
  return payload => async (dispatch, getState) => {
    const paymentsInfo = getState()?.payments;
    const myWalletConfigs = getState()?.payments?.myWallet?.configs || {};
    const isLoggedIn = getState()?.auth?.isLoggedIn || false;
    validatePaymentsInfo(initialState, paymentsInfo, myWalletConfigs);
    const response = await updateStoredValues({
      paymentsInfo,
      payments: {
        icoTradeIn: {
          ...payload
        }
      },
      walletStorageService,
      isLoggedIn
    });
    if (!response?.success) {
      dispatch({
        type: types.UPDATE_MY_WALLET,
        payload: {
          displayWalletErrorMessage: true
        }
      });
    }
    dispatch({
      type: types.UPDATE_ICO_TRADE_IN,
      payload: {
        ...payload
      }
    });
  };
};
export default updateICOTradeIn;